const keys = {
  isEnabled: 'is_enabled',
  isArchived: 'is_archived',
};

export default function createBulkPackagesEditRequest(packages, data) {
  const requestData = {
    package_ids: packages.map((item) => item.id),
    ...Object.entries(data).reduce((acc, [key, value]) => {
      if (keys[key] && value !== null) {
        acc[keys[key]] = value;
      }

      return acc;
    }, {}),
  };

  if (data.discountPercent) {
    requestData.discount_percent = (Number(data.discountPercent) / 100).toFixed(3);
  }

  return requestData;
}
